import React from 'react';
import Select from 'react-select';
import { COUNTRIES, CountryBadge, getCountryFlag } from '../utils/countries';
export { CountryBadge, getCountryFlag };

const options = COUNTRIES.map(country => ({
  value: country,
  label: country,
}));

export const SearchableCountrySelect = ({ value, onChange, className }) => {
  const selectedOption = options.find(o => o.value === value) || (value === 'ALL' ? { value: 'ALL', label: '🌐 All Countries' } : null);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '38px',
      borderRadius: '0.75rem',
      borderColor: '#e2e8f0',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#cbd5e1'
      }
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#db2777' : state.isFocused ? '#fce7f3' : 'white',
      color: state.isSelected ? 'white' : '#334155',
      fontSize: '0.875rem'
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 50,
      borderRadius: '0.75rem',
      overflow: 'hidden'
    })
  };

  const handleChange = (selected) => {
    onChange(selected ? selected.value : '');
  };

  return (
    <Select
      value={selectedOption}
      onChange={handleChange}
      options={options}
      styles={customStyles}
      className={className}
      isClearable={false}
      isSearchable={true}
      placeholder="Select Country..."
    />
  );
};

export const FilterCountrySelect = ({ value, onChange, className }) => {
  const filterOptions = [{ value: 'ALL', label: '🌐 All Countries' }, ...options];
  const selectedOption = filterOptions.find(o => o.value === value);

  const customStyles = {
    control: (provided) => ({
      ...provided,
      minHeight: '38px',
      borderRadius: '1rem',
      borderColor: 'transparent',
      backgroundColor: 'transparent',
      boxShadow: 'none',
      border: 'none',
      cursor: 'pointer',
      fontWeight: 'bold',
      color: '#334155'
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#db2777' : state.isFocused ? '#fce7f3' : 'white',
      color: state.isSelected ? 'white' : '#334155',
      fontSize: '0.875rem'
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 50,
      minWidth: '200px'
    })
  };

  const handleChange = (selected) => {
    onChange(selected ? selected.value : 'ALL');
  };

  return (
    <Select
      value={selectedOption}
      onChange={handleChange}
      options={filterOptions}
      styles={customStyles}
      className={className}
      isClearable={false}
      isSearchable={true}
    />
  );
};
